var React = require('react');

function IconSmsCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"50.5","cy":"50.1602","r":"50","fill":"#F8F8F8","key":0}),React.createElement("path",{"d":"M23.334 57.058H17.8862M28.0629 55.1445V63.7189C28.0629 65.1167 29.1725 66.25 30.5413 66.25H75.0218C76.3905 66.25 77.5 65.1167 77.5 63.7189V36.2732C77.5 35.2248 76.6679 34.375 75.6414 34.375H29.9217C28.8951 34.375 28.0629 35.2248 28.0629 36.2732V45.5598V55.1445ZM76.9528 34.9338L57.5059 51.2522C54.7639 53.5666 50.799 53.5666 48.0572 51.2522L28.6115 34.9351L76.9528 34.9338ZM23.1581 43.4721H16.25H23.1581ZM31.157 50.2855H19.8593H31.157Z","stroke":"black","strokeWidth":"1.875","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconSmsCircle.defaultProps = {"width":"101","height":"101","viewBox":"0 0 101 101","fill":"none"};

module.exports = IconSmsCircle;

IconSmsCircle.default = IconSmsCircle;
